import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

const PaymentCancelled = () => (
  <div className="min-h-screen flex items-center justify-center px-4 py-16" style={{ background: "var(--awd-bg)" }} data-testid="payment-cancelled">
    <div className="max-w-xl w-full text-center">
      <div className="kente-stripe mb-12" />
      <XCircle size={56} className="mx-auto" style={{ color: "var(--awd-jollof)" }} />
      <h1 className="font-display text-5xl mt-6 leading-none">
        Checkout <span className="italic" style={{ color: "var(--awd-ochre)" }}>cancelled</span>.
      </h1>
      <p className="mt-4 text-lg" style={{ color: "var(--awd-text-2)" }}>
        No payment was taken. Your cart is empty — head back and try again whenever you're ready.
      </p>
      <div className="mt-10">
        <Link to="/" className="btn-primary inline-flex"><ArrowLeft size={16} /> Back to menu</Link>
      </div>
    </div>
  </div>
);

export default PaymentCancelled;
